import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Primary } from "@cinch-labs/design-system";
import { getStoryblokImageServiceUrl } from "@cinch-nx/data-storyblok";
import styles from "./ev-pre-footer.module.css";
const handleClick = (url)=>{
    window.open(url, "_blank");
};
export const EvPreFooter = ({ evCta , image  })=>{
    const { label , url  } = evCta[0];
    const { filename , alt  } = image;
    const sbImageUrl = getStoryblokImageServiceUrl(filename, {
        filters: [
            {
                quality: 80
            }
        ]
    });
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(Primary, {
                type: "submit",
                "data-testid": "ev-button",
                onClick: ()=>handleClick(url),
                children: label
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx("img", {
                    className: styles.preFooterImage,
                    src: sbImageUrl,
                    alt: alt ? alt : "pre footer image"
                })
            })
        ]
    });
};
